'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArchive = function IoArchive(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 24.1l-10-9.1h6.3v-7.5h7.5v7.5h6.2z m16.3-0.9c0.9 0.5 1.4 1.5 1.2 2.5l-0.7 5.2c-0.2 1.1-0.7 1.6-2.2 1.6h-29.2c-1.4 0-2-0.5-2.2-1.6l-0.7-5.2c-0.2-1 0.2-2 1.1-2.5l5.6-4.3h3.3l-4.8 4.9h3.9c0.1 0 0.4 0 0.4 0.2l1.4 3.5h13.2l1.4-3.5c0-0.2 0.2-0.2 0.4-0.2h3.9l-4.8-4.9h3.3z' })
        )
    );
};

exports.default = IoArchive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/archive.js
// module id = 2165
// module chunks = 0